// Gerencia período de graça para operação offline do kiosk
const GRACE_PERIOD_DAYS = 30;
const GRACE_PERIOD_MS = GRACE_PERIOD_DAYS * 24 * 60 * 60 * 1000;
const ADMIN_EXTEND_DAYS = 7;

export const offlineStore = {
	get lastVerified(): number | null {
		const value = localStorage.getItem("lastVerified");
		return value ? Number.parseInt(value, 10) : null;
	},

	// Atualiza timestamp de verificação (chamar após fetch bem-sucedido)
	updateLastVerified() {
		localStorage.setItem("lastVerified", Date.now().toString());
	},

	// Verifica se período de graça expirou
	get isGracePeriodExpired(): boolean {
		const lastVerified = this.lastVerified;
		if (!lastVerified) return false;
		return Date.now() - lastVerified > GRACE_PERIOD_MS;
	},

	// Dias restantes no período de graça
	get daysRemaining(): number {
		const lastVerified = this.lastVerified;
		if (!lastVerified) return GRACE_PERIOD_DAYS;
		const elapsed = Date.now() - lastVerified;
		const remaining = GRACE_PERIOD_MS - elapsed;
		return Math.max(0, Math.ceil(remaining / (24 * 60 * 60 * 1000)));
	},

	// Estende período de graça (usado pelo admin override)
	extendGracePeriod() {
		const extendedTime =
			Date.now() - GRACE_PERIOD_MS + ADMIN_EXTEND_DAYS * 24 * 60 * 60 * 1000;
		localStorage.setItem("lastVerified", extendedTime.toString());
	},

	clear() {
		localStorage.removeItem("lastVerified");
	},
};
